$(document).ready(function () {

    cafm.handlers.set("cafm.unmountReactDisposable", function (ReactDOM, element) {

        var jContainer = element.closest('.main,.actionPanel');
        var disps = jContainer.data('reactDisposables') || [];

        if (jContainer.hasClass("main")) {
            $(".context-container").each(function (i, item) {

                var ccdisps = $(item).data('reactDisposables');
                if (cafm.util.hasItem(ccdisps)) {
                    disps.push(ccdisps);
                }
            })
        }

        //alert("unmountReactDisposable {0}: {1}".format(jContainer[0].id, disps.length));
        if (cafm.util.hasItem(disps)) {
            disps.forEach(function (node) {
                //console.info('unmountComponentAtNode: ' + node.id);
                ReactDOM.unmountComponentAtNode(node);
            });
            jContainer.data('react-disposables', []);
        }
    });

    cafm.handlers.set("cafm.renderReactDisposable", function (ReactDOM, element, container, callback) {

        if (container instanceof jQuery) {
            container = container.get(0);
        }
        if (!container) return;
        let instance = ReactDOM.render(element, container, callback);
        let jContainer = $(container).addClass('react-container').closest('.main,.actionPanel');
        let disps = jContainer.data('reactDisposables') || [];
        disps.push(container);
        jContainer.data('reactDisposables', disps);
        return instance;
    });

    if (!cafm.dom.cookiesEnabled() && !cafm.url.isBrowserInfo() && !cafm.url.isError()) {

        cafm.url.set('~/error/cookiesnotenabled');
    }

    window.body = $(document.body);
    window.isSingleCol = body.hasClass('singleCol');
    window.isMobile = body.hasClass('mobile');
    window.isTouch = false;

    cafm.kendo.ext.init();
    cafm.kendo.bindings.init();
    cafm.router.init();
    cafm.actions.init();

    cafm.web.ready();

    if (cafm.readyBegin && cafm.readyBegin.length) {
        $.each(cafm.readyBegin, function (i, readyItem) {
            readyItem();
        });
    }

    if (cafm.browsers.isTouchAble()) {

        cafm.browsers.setIsTouchAble(true); // add body class and set flag
        $('.switchViewType').show();
    }
    
    // set up the column layout if applicable
    cafm.layout.init();

    if (cafm.readyEnd && cafm.readyEnd.length) {
        $.each(cafm.readyEnd, function (i, readyItem) {
            readyItem();
        });
    }    
});